import { GridRow } from '@/components/ui/layouts/grids/GridRow';
import { Section } from '@/components/ui/layouts/sections/Section';
import { Icon } from '@mage-ui/components';
import { gridRow, icon, link } from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { Instances } from '../Instances';

export const LanguageBlock = ({ data }) => {
  return (
    <Section
      heading={{
        title: data?.fields?.title,
        epi: data?.fields?.epi,
      }}
      footer={
        (data?.cta_text || data?.fields?.cta_text) && (
          <Link
            href={data?.cta_slug || data?.fields?.cta_slug || '#'}
            className={link({ size: 'l' })}
          >
            {data?.fields?.cta_text}
            <Icon name='arrow_long_forward' classNames={icon({ size: 'l' })} />
          </Link>
        )
      }
    >
      <GridRow
        className={gridRow({
          colGapM: 'gap800',
          colGapL: 'gap900',
        })}
      >
        <Instances
          key={data?.meta?.key}
          instances={data?.relations?.LanguageList?.map((item) => ({
            ...item,
            fields: {
              ...item?.fields,
              displayValue:
                item?.fields?.alias !== '' &&
                item?.fields?.alias !== undefined &&
                item?.fields?.alias !== null
                  ? item?.fields?.alias
                  : item?.fields?.iso || '',
            },
          }))}
        />
      </GridRow>
    </Section>
  );
};
